/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Needanyhelp2Inputs */

const en_settings_needanyhelp2 = /** @type {(inputs: Settings_Needanyhelp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need any help?`)
};

/**
* | output |
* | --- |
* | "Need any help?" |
*
* @param {Settings_Needanyhelp2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_needanyhelp2 = /** @type {((inputs?: Settings_Needanyhelp2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Needanyhelp2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_needanyhelp2(inputs)
});
export { settings_needanyhelp2 as "settings_needAnyHelp" }